/* tslint:disable */
 
import { LocalizedValue } from './localized-value';
import { WorkflowStep } from './workflow-step';
export class DataEntityWorkflow {
  id?: string;
  isDefault: boolean;
  name: LocalizedValue;
  steps: Array<WorkflowStep>;
}
